export { default } from './ApplicationFooter';
export { default as ApplicationFooter } from './ApplicationFooter';
